<template>
  <div
    id="leaderboard"
    :style="{ backgroundColor: isDarkTheme ? shadowBgColor : '#ffffff' }"
    style="margin: 10px !important;"
  >
    <!-- Copy Modal -->
    <div v-if="showCopyModal" class="copy-modal-overlay" @click="closeCopyModal">
      <div class="copy-modal" @click.stop>
        <div class="copy-modal-header">Share Text</div>
        <textarea
          ref="shareTextArea"
          class="copy-modal-text"
          readonly
          :value="copyModalText"
        ></textarea>
        <div class="copy-modal-buttons">
          <button class="copy-modal-btn copy-btn" @click="copyAndClose">Copy</button>
          <button class="copy-modal-btn close-btn" @click="closeCopyModal">Close</button>
        </div>
      </div>
    </div>

    <div
      :style="{ backgroundColor: isDarkTheme ? shadowBgColor : '#ffffff' }"
      class="modal-dialog bg-light"
      style="margin: 10px 0px !important;"
    >
      <div class="padding-horizontal-10 font-bold" style="color: #000000;">
        Game Leaderboard
      </div>

      <div style="color: #000000;" class="ranking-rewards-wrapper">
        <table class="ranking-rewards text-center">
          <tr>
            <th style="padding: 10px 5px;" class="font-medium font-bold">
              Rank
            </th>
            <th class="font-medium font-bold">Player</th>
            <th class="font-medium font-bold">Score</th>
            <th class="font-medium font-bold">Prize</th>
          </tr>

          <tr
            v-for="player in model"
            :style="{ backgroundColor: isDarkTheme ? topBgColor : bgTheme }"
          >
            <td style="padding: 5px !important; font-size: 12px;">
              {{ player.rank }}
            </td>

            <td style="padding: 5px !important;">
              <div class="align-hor center-ver" style="width: 110px;">
                <div
                  class="text-center margin-right-5"
                  style="border-radius: 50%; height: 32px; width: 32px; margin-right: 20px;"
                  :style="{
                    backgroundColor: isDarkTheme ? topBgColor : bgTheme
                  }"
                ></div>

                <div
                  v-if="player.name"
                  style="font-size: 12px;"
                  class="player-name"
                >
                  {{ player.name }}
                </div>
                <div v-else style="font-size: 12px;" class="player-name">
                  {{ player.mobile }}
                </div>
              </div>
            </td>

            <td style="padding: 5px !important; font-size: 12px;">
              {{ player.score }}
            </td>

            <td style="padding: 5px !important;font-size: 12px;">
              {{ player.prize }} {{ player.prize_type }}
            </td>
          </tr>
        </table>
      </div>

      <div
        class="bg-light padding-10 align-hor center-hor center-ver"
        :style="{ backgroundColor: isDarkTheme ? shadowBgColor : '#ffffff' }"
        @click.capture="shareRank"
      >
        <button
          class="custom-button text-light align-hor center-hor center-ver share-btn"
          @click.capture.stop="shareRank"
          :style="{
            backgroundColor: isDarkTheme ? topBgColor : bgTheme,
            padding: '10px',
            borderRadius: '3px',
            cursor: 'pointer',
            width: '100%',
            position: 'relative',
            zIndex: 9999,
            pointerEvents: 'auto'
          }"
        >
          <div class="margin-right-10" style="pointer-events: none;">Share your rank</div>
          <img style="width: 20px; height: 20px; pointer-events: none;" src="@/assets/share.png" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { globals } from "@/mixins/globals";
import axios from "axios";

export default {
  mixins: [globals],
  props: {
    model: Array,

    // Only offerId needed — backend will generate full WhatsApp message
    offerId: {
      type: Number,
      default: -1
    },

    // Game name for custom share message
    gameName: {
      type: String,
      default: ""
    },

    // Share link from parent
    shareLink: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      cachedShareLink: null,
      showCopyModal: false,
      copyModalText: "",
      isSharing: false
    };
  },
  mounted() {
    // Pre-fetch share link when component loads
    this.prefetchShareLink();
  },
  watch: {
    offerId: {
      handler() {
        // Re-fetch if offerId changes
        this.prefetchShareLink();
      }
    }
  },
  methods: {
    // Extract URL from text
    extractURL(text) {
      var regex = /(https?:\/\/[^\s]+)/;
      var match = text && text.match(regex);
      return match ? match[0] : "";
    },

    // Get user's score from model (first item is current user)
    getUserScore() {
      if (this.model && this.model.length > 0) {
        return this.model[0].score || 0;
      }
      return 0;
    },

    // Get game name from prop or store
    getGameName() {
      if (this.gameName) {
        return this.gameName;
      }
      if (this.$store && this.$store.state && this.$store.state.gameName) {
        return this.$store.state.gameName;
      }
      return "game";
    },

    // Build custom share message
    buildShareMessage(link) {
      const score = this.getUserScore();
      const game = this.getGameName();
      return `Hi, I have scored ${score} in this ${game}. Checkout the app to compete with me!! ${link}`;
    },

    // Pre-fetch share link when component loads
    async prefetchShareLink() {
      // If shareLink prop is provided, use it
      if (this.shareLink) {
        this.cachedShareLink = this.shareLink;
        console.log("Using shareLink prop:", this.cachedShareLink);
        return;
      }

      if (this.offerId === -1) return;

      let baseDomain = this.$store.getters.gamesDomain.replace("/v2", "");
      let url = baseDomain + "/get_share_link/?offer_id=" + this.offerId;
      let headers = this.$store.getters.headers;

      try {
        const resp = await axios.get(url, { headers });
        if (resp.status == 200 && resp.data.success) {
          // Extract just the link from the response message
          this.cachedShareLink = this.extractURL(resp.data.message);
          console.log("Share link pre-fetched:", this.cachedShareLink);
        }
      } catch (err) {
        console.log("Prefetch share link error:", err);
      }
    },

    // Button click handler - uses cached link for immediate share
    async shareRank() {
      // Prevent double-clicks
      if (this.isSharing) {
        console.log("Share already in progress");
        return;
      }
      this.isSharing = true;

      console.log("shareRank clicked, offerId:", this.offerId);

      // Use cached link if available, otherwise fetch
      let link = this.cachedShareLink || this.shareLink;

      if (!link) {
        // Fallback: fetch now (might fail due to user activation timeout)
        let baseDomain = this.$store.getters.gamesDomain.replace("/v2", "");
        let url = baseDomain + "/get_share_link/?offer_id=" + this.offerId;
        let headers = this.$store.getters.headers;

        try {
          const resp = await axios.get(url, { headers });
          if (resp.status == 200 && resp.data.success) {
            link = this.extractURL(resp.data.message);
          }
        } catch (err) {
          console.log("Share fetch error:", err);
          this.isSharing = false;
          return;
        }
      }

      if (!link) {
        console.log("No share link available");
        this.isSharing = false;
        return;
      }

      // Build custom share message
      const shareText = this.buildShareMessage(link);

      // Call navigator.share() directly in iframe
      if (navigator.share) {
        try {
          await navigator.share({
            title: "My Leaderboard Rank",
            text: shareText
          });
          console.log("Share successful");
        } catch (err) {
          console.log("Share cancelled or failed:", err);
          // Only show fallback if not user-cancelled (AbortError)
          if (err.name !== "AbortError") {
            this.fallbackShare(shareText);
          }
        }
      } else {
        console.log("navigator.share not supported");
        this.fallbackShare(shareText);
      }

      this.isSharing = false;
    },

    // Fallback for browsers without Web Share API
    fallbackShare(text) {
      this.copyModalText = text;
      this.showCopyModal = true;
    },

    copyAndClose() {
      const text = this.copyModalText;
      // Select text in textarea
      if (this.$refs.shareTextArea) {
        this.$refs.shareTextArea.select();
        this.$refs.shareTextArea.setSelectionRange(0, 99999);
      }
      // Try to copy
      if (navigator.clipboard) {
        navigator.clipboard.writeText(text)
          .then(() => {
            alert("Copied to clipboard!");
            this.closeCopyModal();
          })
          .catch(() => {
            // execCommand fallback
            document.execCommand("copy");
            alert("Copied to clipboard!");
            this.closeCopyModal();
          });
      } else {
        document.execCommand("copy");
        alert("Copied to clipboard!");
        this.closeCopyModal();
      }
    },

    closeCopyModal() {
      this.showCopyModal = false;
      this.copyModalText = "";
    }
  },
  computed: {
    isDarkTheme() {
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.isDarkTheme &&
        this.$store.state.sdkEvent.isDarkTheme
      ) {
        return this.$store.state.sdkEvent.isDarkTheme;
      }
      return null;
    },
    shadowBgColor() {
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.shadowBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.shadowBgColor;
      }
      return null;
    },
    topBgColor() {
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.topBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.topBgColor;
      }
      return null;
    }
  }
}
</script>

<style>
.player-name {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
#leaderboard .ranking-rewards {
  border-collapse: collapse;
  width: 100%;
}
#leaderboard .ranking-rewards td {
  padding: 5px 10px;
}
#leaderboard .ranking-rewards tr:nth-child(2) {
  --bgcolor: #666666;
  background-color: var(--bgcolor);
  color: #ffffff;
}
.ranking-rewards-wrapper {
  height: auto;
  overflow: scroll;
  max-height: 500px;
}

/* Copy Modal Styles */
.copy-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
}
.copy-modal {
  background: #ffffff;
  border-radius: 10px;
  padding: 20px;
  width: 90%;
  max-width: 350px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}
.copy-modal-header {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin-bottom: 15px;
  text-align: center;
}
.copy-modal-text {
  width: 100%;
  height: 100px;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 14px;
  resize: none;
  box-sizing: border-box;
  color: #333;
  background: #f9f9f9;
}
.copy-modal-buttons {
  display: flex;
  gap: 10px;
  margin-top: 15px;
}
.copy-modal-btn {
  flex: 1;
  padding: 12px;
  border: none;
  border-radius: 5px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
}
.copy-modal-btn.copy-btn {
  background: #007AFF;
  color: #fff;
}
.copy-modal-btn.close-btn {
  background: #e0e0e0;
  color: #333;
}
</style>
